import { Box, Flex, Icon, Text } from '@chakra-ui/react';
import { Link as RouterLink } from 'react-router-dom'

export interface BottomNavItemProps {
  icon: React.ElementType
  label: string
  to?: string
  isActive: boolean
  onClick?: () => void
}

export function BottomNavItem({ icon, label, to, isActive, onClick }: BottomNavItemProps) {
  return (
    <Flex
      {...(to ? { as: RouterLink as React.ElementType, to } : { as: 'button', type: 'button' })}
      onClick={onClick}
      direction="column"
      align="center"
      justify="center"
      flex={1}
      minH="44px"
      py={1}
      color={isActive ? 'brand.600' : 'gray.500'}
      fontWeight={isActive ? 'semibold' : 'normal'}
      _hover={{ textDecoration: 'none', color: isActive ? 'brand.600' : 'gray.700' }}
      transition="color 0.15s"
      bg="transparent"
    >
      <Box
        bg={isActive ? 'brand.50' : 'transparent'}
        borderRadius="full"
        px={4}
        py={1}
        transition="background 0.15s"
      >
        <Icon as={icon} boxSize={6} />
      </Box>
      <Text fontSize="xs" mt={0.5}>
        {label}
      </Text>
    </Flex>
  )
}
